var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductLister',{attrs:{"title":_vm.$t('searchPanel.searchResultHeading',{searchTerm:_vm.term})}})}
var staticRenderFns = []

export { render, staticRenderFns }